import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { STORAGE_ADDRESS, StorageAddressKindValues, STORAGE_ADDRESS_KIND_LABELS, } from '../types/storage-address.js';
import { STORAGE_ADDRESS_PATTERN } from '../types/storage-address-pattern.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for StorageAddress entity (0115, revised 0168).
 * Stored in 'org/{orgId}/storage-address'.
 */
export const storageAddressDescriptor = {
    name: STORAGE_ADDRESS,
    label: 'Endereço de armazenamento',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/storage-address',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 2,
    description: 'Physical storage address inside a CD — scan code unique per CD, immutable after create',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique storage address identifier',
        },
        {
            name: 'distributionCenterId',
            label: 'Centro de distribuição',
            type: 'string',
            required: true,
            description: 'FK to DistributionCenter that hosts this address',
        },
        {
            name: 'patternId',
            label: 'Padrão',
            type: 'string',
            required: false,
            description: 'FK to StorageAddressPattern; null = free-form typed code',
        },
        {
            name: 'components',
            label: 'Componentes',
            type: 'object',
            required: false,
            description: 'Array of { key, value } in pattern order; empty when free-form',
        },
        {
            name: 'code',
            example: 'A-03-02-1',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.BARCODE,
            description: 'Scan code — unique per CD; immutable after create',
        },
        {
            name: 'kind',
            example: 'picking',
            label: 'Tipo',
            type: 'enum',
            required: true,
            enumValues: [...StorageAddressKindValues],
            enumLabels: STORAGE_ADDRESS_KIND_LABELS,
            description: 'picking | bulk | staging | dock',
        },
        {
            name: 'capacity',
            example: 40,
            label: 'Capacidade',
            type: 'number',
            required: false,
            description: 'Informative capacity (not enforced)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'distributionCenterId',
            targetEntity: 'DistributionCenter',
            relationship: 'many-to-one',
            description: 'Distribution center that hosts this address',
            displayField: 'name',
        },
        {
            fieldName: 'patternId',
            targetEntity: STORAGE_ADDRESS_PATTERN,
            relationship: 'many-to-one',
            description: 'Pattern that assembled this address code',
            displayField: 'name',
        },
    ],
};
//# sourceMappingURL=storage-address.descriptor.js.map